import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardLocalitaService from "./dashboardLocalitaService";
import { Form, InputGroup } from "react-bootstrap";
import { BsFillCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import ingiunzioniList from "../../../common/mookup/MookUpIngunzioni";
import { Modal, Button, Row } from "react-bootstrap";
toast.configure();

class Localita extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Localita: [
        {
          idLocalita: 0,
          idArea: 0,
          idLinea: 0,
          nomeLocalita: "",
          idCliente: "",
          importo: 0,
          statobottne: true,
        },
      ],
      aree: [
        {
          idArea: 0,
          nomeArea: "",
          idCliente: "",
          statobottne: true,
        },
      ],
      linee: [
        {
          idLinea: 0,
          nomeLinea: "",
          idCliente: "",
          statobottne: true,
        },
      ],
      nuuovaLocalita: {
        nomeLocalita: "",
        idLinea: 0,
        idArea: 0,
        importo: 0,
      },
      editLocalita: {
        idLocalita: 0,
        idLinea: 0,
        nomeLocalita: "",
        idCliente: 0,
        idArea: 0,
        importo: 0,
      },
      abilitazioneDiModificaSuUnLinea: [], //è un array di chiavi per abilitare e disabilitare un bottone di un area
      loading: true,
      abilitaModificaLinea: [],
      eliminaModal: false,
      idDaEliminare: 0,
      AggiungiUnaLinea: false,
      nomeLocalita: "",
      valoreAreePerFiltrare: 0,
      valoreLineePerFiltrare: 0,
      loadingButton:false,
    };
  }

  componentDidMount() {
    this.dashboardLocalitaService = new DashboardLocalitaService();
    
    this.dashboardLocalitaService.getDataTableLenee((Linee) => {
      this.state.linee = Linee.data;
      this.dashboardLocalitaService.getDataTableAree((Aree) => {
        this.state.aree = Aree.data;
        this.dashboardLocalitaService.getDataTableLocalita((localita) => {
          localita.data.map((localita) => {
            localita.statobottne = true;
            localita.bottoniEditi = true;
            localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")
    
            this.state.aree.map((val) => {
              if (val.idArea === localita.idArea) {
                localita.idArea = val.nomeArea;
              }
            });
            this.state.linee.map((val) => {
              if (val.idLinea === localita.idLinea) {
                localita.idLinea = val.nomeLinea;
              }
            });
    
            // localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")
          });
          this.setState({ Localita: localita.data });
        });
      });
    });
   

    this.setState({ loading: false });
  }

  annullaElimina() {
    this.setState({ eliminaModal: false });
  }

  confremaElimna() {
    this.setState({loadingButton:true})
    this.dashboardLocalitaService.deleteLocalita(
      this.state.idDaEliminare,
      (result) => {
        this.setState({loadingButton:false})
        if (result.status === 200) {
          toast.success("Eliminato con successo");
        } else {
          toast.error("Qualcosa è andato storto");
        }
        this.dashboardLocalitaService.getDataTableLocalita((Linee) => {
          Linee.data.map((localita) => {
            localita.statobottne = true;
            localita.bottoniEditi = true;

            this.state.aree.map((val) => {
              if (val.idArea === localita.idArea) {
                localita.idArea = val.nomeArea;
              }
            });
            this.state.linee.map((val) => {
              if (val.idLinea === localita.idLinea) {
                localita.idLinea = val.nomeLinea;
              }
            });
            localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")
          });

          this.setState({ Localita: Linee.data, eliminaModal: false });
        });
      }
    );
  }

  eliminaModal() {
    return (
      <>
        <Modal size="sm" show={this.state.eliminaModal}>
          <Modal.Header>
            <Modal.Title>Elimina Località</Modal.Title>
          </Modal.Header>
          <Modal.Body>Sei sicuro di eliminare la Località?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaElimina.bind(this)}
            >
              Annulla
            </Button>
            <Button variant="danger" disabled={this.state.loadingButton} onClick={this.confremaElimna.bind(this)}>
            {this.state.loadingButton ? <LoadSpinner/> : "Elimina Località"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  annullaAggiungi() {
    this.setState({
      AggiungiUnaLinea: false,
      nomeLocalita: "",
      nuuovaLocalita: { nomeLocalita: "", idLinea: 0, idArea: 0, importo: 0 },
    });
  }

  confremaAggiungi() {
    // this.nuovoLocalita = {
    //   nomeLocalita: this.state.Localita.nomeLocalita,
    //   idLinea: this.state.linee.idLinea,
    //   idArea: this.state.aree.idArea,
    //   importo: this.state.Localita.importo,
    // 
    // if(this.state.nuuovaLocalita.importo.toString().includes(".")){
    // this.state.nuuovaLocalita.importo = this.state.nuuovaLocalita.importo.toString().replace(".","")
    // }
    // if(this.state.nuuovaLocalita.importo.toString().includes(",")){
    // this.state.nuuovaLocalita.importo = this.state.nuuovaLocalita.importo.toString().replace(",","")
    // }
    // this.state.nuuovaLocalita.importo = this.state.nuuovaLocalita.importo.toString().length === 1 ? parseInt(this.state.nuuovaLocalita.importo * 100) : this.state.nuuovaLocalita.importo


    var importointero = this.state.nuuovaLocalita.importo.toString().replace(".", "");

      if (
        this.state.nuuovaLocalita.importo.toString().includes(".") ||
        this.state.nuuovaLocalita.importo.toString().includes(",")
      ) {
        this.state.nuuovaLocalita.importo = parseFloat(importointero);
      } else {
        this.state.nuuovaLocalita.importo = parseFloat(importointero * 100);
      }

    this.setState({loadingButton:true})
    this.dashboardLocalitaService.insertLocalita(
      this.state.nuuovaLocalita,
      (result) => {
        this.setState({loadingButton:false})
        if (result.status === 200) {
          toast.success("Localita aggiunta con successo");
        } else {
          toast.error("Qualcosa è andato storto");
        }

        //   this.dashboardLocalitaService.getDataTableLocalita((Localita) => {
        //     Localita.data.map((localita) => {
        //       localita.statobottne = true;
        //       localita.bottoniEditi = true;
        //     });
        //     this.setState({
        //       localita: Localita.data,
        //       AggiungiUnaLinea: false,
        //       nomeLocalita: "",
        //     });
        //   });
        this.dashboardLocalitaService.getDataTableLocalita((localita) => {
          localita.data.map((localita) => {
            localita.statobottne = true;
            localita.bottoniEditi = true;
            localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")

            this.state.aree.map((val) => {
              if (val.idArea === localita.idArea) {
                localita.idArea = val.nomeArea;
              }
            });
            this.state.linee.map((val) => {
              if (val.idLinea === localita.idLinea) {
                localita.idLinea = val.nomeLinea;
              }
            });
            // localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")
          });
          this.setState({
            Localita: localita.data,
            AggiungiUnaLinea: false,
            nuuovaLocalita: {
              nomeLocalita: "",
              idLinea: 0,
              idArea: 0,
              importo: 0,
            },
          });
        });
      }
    );
  }

  onChangeNuovaLinea(event) {
    this.state.nuuovaLocalita.nomeLocalita = event.target.value;
    this.setState({ nuuovaLocalita: this.state.nuuovaLocalita });
  }
  onChangeNomeLocalita(event) {
    this.state.nuuovaLocalita.nomeLocalita = event.target.value;
    this.setState({ nuuovaLocalita: this.state.nuuovaLocalita });
  }

  onChangeNomeArea(event) {
    this.state.nuuovaLocalita.idArea = parseInt(event.target.value);
    this.setState({ nuuovaLocalita: this.state.nuuovaLocalita });
  }

  onChangeNomeLinea(event) {
    this.state.nuuovaLocalita.idLinea = parseInt(event.target.value);
    this.setState({ nuuovaLocalita: this.state.nuuovaLocalita });
  }

  onChangeImporto(event) { 
    this.state.nuuovaLocalita.importo = event.target.value
    this.setState({ nuuovaLocalita: this.state.nuuovaLocalita });
  }

  AggiungiUnaLinea() {
    return (
      <>
        <Modal size="lg" show={this.state.AggiungiUnaLinea}>
          <Modal.Header>
            <Modal.Title>Aggiungi una nuova Località</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label>Nome Località</label>
            <input
              className="form-control"
              type="text"
              value={this.state.nuuovaLocalita.nomeLocalita}
              onChange={this.onChangeNomeLocalita.bind(this)}
            />
            <div className="row">
              <div className="col">
                <label>Nome Area</label>
                {/* <input
                  className="form-control"
                  type="text"
                  value={this.state.nomeLocalita}
                  onChange={this.onChangeNuovaLinea.bind(this)}
                /> */}

                <select
                  className="form-control"
                  onChange={this.onChangeNomeArea.bind(this)}
                >
                  {this.state.aree.map((val, index) => {
                    return (
                      <>
                        {" "}
                        {index === 0 ? (
                          <option selected value={0} placeholder="Seleziona">
                            {"Seleziona"}
                          </option>
                        ) : (
                          ""
                        )}
                        <option value={val.idArea}>{val.nomeArea}</option>
                      </>
                    );
                  })}
                </select>
              </div>
              <div className="col">
                <label>Nome Linea</label>
                {/* <input
                  className="form-control"
                  type="text"
                  value={this.state.nomeLocalita}
                  onChange={this.onChangeNuovaLinea.bind(this)}
                /> */}
                <select
                  className="form-control"
                  onChange={this.onChangeNomeLinea.bind(this)}
                >
                  {this.state.linee.map((val, index) => {
                    return (
                      <>
                        {" "}
                        {index === 0 ? (
                          <option selected value={0} placeholder="Seleziona">
                            {"Seleziona"}
                          </option>
                        ) : (
                          ""
                        )}
                        <option value={val.idLinea}>{val.nomeLinea}</option>
                      </>
                    );
                  })}
                </select>
              </div>
            </div>
            <label>Importo</label>
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text">€</span>
              </div>
              <input
                className="form-control"
                type="number"
                value={this.state.nuuovaLocalita.importo}
                onChange={this.onChangeImporto.bind(this)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaAggiungi.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              disabled={this.state.loadingButton ||this.state.nuuovaLocalita.idArea === 0 || this.state.nuuovaLocalita.idLinea === 0 || this.state.nuuovaLocalita.nomeLocalita.length < 3}
              onClick={this.confremaAggiungi.bind(this)}
            >
              {this.state.loadingButton ? <LoadSpinner/> : "Aggiungi Località"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  filtroAree(event) {
    // console.log(event.target.value);
    this.state.valoreAreePerFiltrare = event.target.value;
    if (parseInt(this.state.valoreLineePerFiltrare) > 0) {
      if (parseInt(event.target.value) === 0) {
        this.dashboardLocalitaService.getDataTableLocalita((localita) => {
          this.tabellaFiltrataLocalita = [];
          localita.data.map((localita) => {
            localita.statobottne = true;
            localita.bottoniEditi = true;
            localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")
            if (parseInt(this.state.valoreLineePerFiltrare) === localita.idLinea) {
              this.tabellaFiltrataLocalita = [
                ...this.tabellaFiltrataLocalita,
                {
                  idLocalita: localita.idLocalita,
                  idLinea: localita.idLinea,
                  nomeLocalita: localita.nomeLocalita,
                  idCliente: localita.idCliente,
                  idArea: localita.idArea,
                  importo: localita.importo,
                  statobottne: localita.statobottne,
                  bottoniEditi: localita.bottoniEditi,
                },
              ];
            }
          });
          this.tabellaFiltrataLocalita.map((localita) => {
            this.state.aree.map((val) => {
              if (val.idArea === localita.idArea) {
                localita.idArea = val.nomeArea;
              }
            });
            this.state.linee.map((val) => {
              if (val.idLinea === localita.idLinea) {
                localita.idLinea = val.nomeLinea;
              }
            });
          });
          this.setState({ Localita: this.tabellaFiltrataLocalita });
        });
      } else {
        this.dashboardLocalitaService.getDataTableLocalita((localita) => {
          this.tabellaFiltrataLocalita = [];
          localita.data.map((localita) => {
            localita.statobottne = true;
            localita.bottoniEditi = true;
            localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")
            if (parseInt(event.target.value) === localita.idArea && parseInt(this.state.valoreLineePerFiltrare) === localita.idLinea) {
              this.tabellaFiltrataLocalita = [
                ...this.tabellaFiltrataLocalita,
                {
                  idLocalita: localita.idLocalita,
                  idLinea: localita.idLinea,
                  nomeLocalita: localita.nomeLocalita,
                  idCliente: localita.idCliente,
                  idArea: localita.idArea,
                  importo: localita.importo,
                  statobottne: localita.statobottne,
                  bottoniEditi: localita.bottoniEditi,
                },
              ];
            }
          });
          this.tabellaFiltrataLocalita.map((localita) => {
            this.state.aree.map((val) => {
              if (val.idArea === localita.idArea) {
                localita.idArea = val.nomeArea;
              }
            });
            this.state.linee.map((val) => {
              if (val.idLinea === localita.idLinea) {
                localita.idLinea = val.nomeLinea;
              }
            });
          });
          this.setState({ Localita: this.tabellaFiltrataLocalita });
        });
      }
    }else{
    if (parseInt(event.target.value) === 0) {
      this.dashboardLocalitaService.getDataTableLocalita((localita) => {
        this.tabellaFiltrataLocalita = [];
        localita.data.map((localita) => {
          localita.statobottne = true;
          localita.bottoniEditi = true;
          localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")

          this.state.aree.map((val) => {
            if (val.idArea === localita.idArea) {
              localita.idArea = val.nomeArea;
            }
          });
          this.state.linee.map((val) => {
            if (val.idLinea === localita.idLinea) {
              localita.idLinea = val.nomeLinea;
            }
          });
        });
        this.setState({ Localita: localita.data });
      });
    } else {
      this.dashboardLocalitaService.getDataTableLocalita((localita) => {
        this.tabellaFiltrataLocalita = [];
        localita.data.map((localita) => {
          localita.statobottne = true;
          localita.bottoniEditi = true;
          localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")
          if (parseInt(event.target.value) === localita.idArea) {
            this.tabellaFiltrataLocalita = [
              ...this.tabellaFiltrataLocalita,
              {
                idLocalita: localita.idLocalita,
                idLinea: localita.idLinea,
                nomeLocalita: localita.nomeLocalita,
                idCliente: localita.idCliente,
                idArea: localita.idArea,
                importo: localita.importo,
                statobottne: localita.statobottne,
                bottoniEditi: localita.bottoniEditi,
              },
            ];
          }
        });
        this.tabellaFiltrataLocalita.map((localita) => {
          this.state.aree.map((val) => {
            if (val.idArea === localita.idArea) {
              localita.idArea = val.nomeArea;
            }
          });
          this.state.linee.map((val) => {
            if (val.idLinea === localita.idLinea) {
              localita.idLinea = val.nomeLinea;
            }
          });
        });
        this.setState({ Localita: this.tabellaFiltrataLocalita });
      });
    }
  }
}

  filtroLinee(event) {
    // console.log(event.target.value);
    this.state.valoreLineePerFiltrare = event.target.value;

    if (parseInt(this.state.valoreAreePerFiltrare) > 0) {
      if (parseInt(event.target.value) === 0) {
        this.dashboardLocalitaService.getDataTableLocalita((localita) => {
          this.tabellaFiltrataLocalita = [];
          localita.data.map((localita) => {
            localita.statobottne = true;
            localita.bottoniEditi = true;
            localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")
            if (parseInt(this.state.valoreAreePerFiltrare) === localita.idArea) {
              this.tabellaFiltrataLocalita = [
                ...this.tabellaFiltrataLocalita,
                {
                  idLocalita: localita.idLocalita,
                  idLinea: localita.idLinea,
                  nomeLocalita: localita.nomeLocalita,
                  idCliente: localita.idCliente,
                  idArea: localita.idArea,
                  importo: localita.importo,
                  statobottne: localita.statobottne,
                  bottoniEditi: localita.bottoniEditi,
                },
              ];
              // console.log(this.tabellaFiltrataLocalita);
            }

          });
          this.tabellaFiltrataLocalita.map((localita) => {
            this.state.aree.map((val) => {
              if (val.idArea === localita.idArea) {
                localita.idArea = val.nomeArea;
              }
            });
            this.state.linee.map((val) => {
              if (val.idLinea === localita.idLinea) {
                localita.idLinea = val.nomeLinea;
              }
            });
          });
          this.setState({ Localita: this.tabellaFiltrataLocalita });
        });
      } else {
        this.dashboardLocalitaService.getDataTableLocalita((localita) => {
          this.tabellaFiltrataLocalita = [];
          localita.data.map((localita) => {
            localita.statobottne = true;
            localita.bottoniEditi = true;
            localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")
            if (parseInt(event.target.value) === localita.idLinea && parseInt(this.state.valoreAreePerFiltrare) === localita.idArea) {
              this.tabellaFiltrataLocalita = [
                ...this.tabellaFiltrataLocalita,
                {
                  idLocalita: localita.idLocalita,
                  idLinea: localita.idLinea,
                  nomeLocalita: localita.nomeLocalita,
                  idCliente: localita.idCliente,
                  idArea: localita.idArea,
                  importo: localita.importo,
                  statobottne: localita.statobottne,
                  bottoniEditi: localita.bottoniEditi,
                },
              ];
              // console.log(this.tabellaFiltrataLocalita);
            }

          });
          this.tabellaFiltrataLocalita.map((localita) => {
            this.state.aree.map((val) => {
              if (val.idArea === localita.idArea) {
                localita.idArea = val.nomeArea;
              }
            });
            this.state.linee.map((val) => {
              if (val.idLinea === localita.idLinea) {
                localita.idLinea = val.nomeLinea;
              }
            });
          });
          this.setState({ Localita: this.tabellaFiltrataLocalita });
        });
      }
    } else {
      if (parseInt(event.target.value) === 0 ) {
        this.dashboardLocalitaService.getDataTableLocalita((localita) => {
          this.tabellaFiltrataLocalita = [];
          localita.data.map((localita) => {
            localita.statobottne = true;
            localita.bottoniEditi = true;
            localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")

            this.state.aree.map((val) => {
              if (val.idArea === localita.idArea) {
                localita.idArea = val.nomeArea;
              }
            });
            this.state.linee.map((val) => {
              if (val.idLinea === localita.idLinea) {
                localita.idLinea = val.nomeLinea;
              }
            });
          });
          this.setState({ Localita: localita.data });
        });
      } else {
        this.dashboardLocalitaService.getDataTableLocalita((localita) => {
          this.tabellaFiltrataLocalita = [];
          localita.data.map((localita) => {
            localita.statobottne = true;
            localita.bottoniEditi = true;
            localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")
            if (parseInt(event.target.value) === localita.idLinea) {
              this.tabellaFiltrataLocalita = [
                ...this.tabellaFiltrataLocalita,
                {
                  idLocalita: localita.idLocalita,
                  idLinea: localita.idLinea,
                  nomeLocalita: localita.nomeLocalita,
                  idCliente: localita.idCliente,
                  idArea: localita.idArea,
                  importo: localita.importo,
                  statobottne: localita.statobottne,
                  bottoniEditi: localita.bottoniEditi,
                },
              ];
            }
          });
          this.tabellaFiltrataLocalita.map((localita) => {
            this.state.aree.map((val) => {
              if (val.idArea === localita.idArea) {
                localita.idArea = val.nomeArea;
              }
            });
            this.state.linee.map((val) => {
              if (val.idLinea === localita.idLinea) {
                localita.idLinea = val.nomeLinea;
              }
            });
          });
          this.setState({ Localita: this.tabellaFiltrataLocalita });
        });
      }
    }
  }

  onChangeEditArea(event) {
    // const idInput = event.target.id;
    this.state.editLocalita.idArea = event.target.value;
    this.setState({ editLocalita: this.state.editLocalita });
  }
  onChangeEditLinea(event) {
    this.state.editLocalita.idLinea = event.target.value;
    this.setState({ editLocalita: this.state.editLocalita });
  }
  onChangeEditLocalita(event) {}
  onChangeEditImporto(event) {
    const idInput = event.target.id;
    this.state.Localita[idInput].importo = event.target.value;
    this.setState({ localita: this.state.Localita });
  }

  onChangeNomelineea(event) {
    const idInput = event.target.id;
    this.state.Localita[idInput].nomeLocalita = event.target.value;
    this.setState({ localita: this.state.Localita });
  }

  tabellaAree() {
    return (
      <>
        <table class="table table-bordered text-center">
          <thead>
            <tr>
              <th scope="col">Nome Localita</th>
              <th scope="col">
                <div className="row">
                  <div className="col text-left p-1">&nbsp;Nome Area</div>
                  <div className="col">
                    {/* Filtra{" "} */}
                    <select
                      className="form-control"
                      onChange={this.filtroAree.bind(this)}
                    >
                      {this.state.aree.map((val, index) => {
                        return (
                          <>
                            {" "}
                            {index === 0 ? (
                              <option selected value={0} placeholder="Filtra">
                                {"Filtra"}
                              </option>
                            ) : (
                              ""
                            )}
                            <option value={val.idArea}>{val.nomeArea}</option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </th>
              <th scope="col">
                <div className="row">
                  <div className="col text-left p-1">&nbsp;Nome Linea</div>
                  <div className="col">
                    {/* Filtra{" "} */}
                    <select
                      className="form-control"
                      onChange={this.filtroLinee.bind(this)}
                    >
                      {this.state.linee.map((val, index) => {
                        return (
                          <>
                            {" "}
                            {index === 0 ? (
                              <option selected value={0} placeholder="Filtra">
                                {"Filtra"}
                              </option>
                            ) : (
                              ""
                            )}
                            <option value={val.idLinea}>{val.nomeLinea}</option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </th>
              <th scope="col">Importo</th>
              <th scope="col">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {this.state.Localita.map((localita, index) => {
              return (
                <>
                  <tr>
                    <th>
                      <input
                        id={index}
                        disabled={localita.statobottne}
                        className="form-control"
                        type="text"
                        value={localita.nomeLocalita}
                        onChange={this.onChangeNomelineea.bind(this)}
                      />
                    </th>
                    <th>
                      {localita.statobottne === true ? (
                        <input
                          id={index}
                          disabled={localita.statobottne}
                          className="form-control"
                          type="text"
                          value={localita.idArea}
                          // onChange={this.onChangeNomelineea.bind(this)}
                        />
                      ) : (
                        <select
                          className="form-control"
                          onChange={this.onChangeEditArea.bind(this)}
                        >
                          {this.state.aree.map((val2, index2) => {
                            return (
                              <>
                                {val2.nomeArea === localita.idArea ? (
                                  <option selected value={val2.idArea}>
                                    {val2.nomeArea}
                                  </option>
                                ) : (
                                  <option value={val2.idArea}>
                                    {val2.nomeArea}
                                  </option>
                                )}
                              </>
                            );
                          })}
                        </select>
                      )}
                    </th>
                    <th>
                      {localita.statobottne === true ? (
                        <input
                          id={index}
                          disabled={localita.statobottne}
                          className="form-control"
                          type="text"
                          value={localita.idLinea}
                          // onChange={this.onChangeNomelineea.bind(this)}
                        />
                      ) : (
                        <select
                          className="form-control"
                          onChange={this.onChangeEditLinea.bind(this)}
                        >
                          {this.state.linee.map((val3, index3) => {
                            return (
                              <>
                                {val3.nomeLinea === localita.idLinea ? (
                                  <option selected value={val3.idLinea}>
                                    {val3.nomeLinea}
                                  </option>
                                ) : (
                                  <option value={val3.idLinea}>
                                    {val3.nomeLinea}
                                  </option>
                                )}
                              </>
                            );
                          })}
                        </select>
                      )}
                    </th>
                    <th>
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">€</span>
                        </div>
                        <input
                          id={index}
                          disabled={localita.statobottne}
                          className="form-control"
                          type="text"
                          value={localita.importo}
                          onChange={this.onChangeEditImporto.bind(this)}
                        />
                      </div>
                    </th>
                    <td>
                      {localita.bottoniEditi ? (
                        <>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              // this.dashboardLocalitaService.getDataTableLocalita(
                              //   (Linee) => {
                              //     Linee.data.map((localita, indeds) => {
                              //       if (indeds === index) {
                              //         localita.statobottne = false
                              //           localita.bottoniEditi = false
                              //         //   this.setState(localita.bottoniEditi = false);
                              //       } else {
                              //         //   localita.statobottne = true;
                              //         //   localita.bottoniEditi = true;
                              //           localita.statobottne = true
                              //           localita.bottoniEditi = true
                              //       }
                              //     });

                              //     //   console.log(Linee);
                              //     this.setState({ localita: Linee.data });
                              //   }
                              // );
                              // this.setState({ loading: false });

                              this.state.Localita.map((localita, indeds) => {
                                if (indeds === index) {
                                  localita.statobottne = false;
                                  localita.bottoniEditi = false;
                                  //   this.setState(localita.bottoniEditi = false);
                                } else {
                                  //   localita.statobottne = true;
                                  //   localita.bottoniEditi = true;
                                  localita.statobottne = true;
                                  localita.bottoniEditi = true;
                                }
                              });

                              //   console.log(Linee);
                              this.setState({ localita: localita });
                            }}
                          >
                            {" "}
                            <i className="fas fa-fw fa-edit"></i>{" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            onClick={() =>
                              this.setState({
                                eliminaModal: true,
                                idDaEliminare:
                                  this.state.Localita[index].idLocalita,
                              })
                            }
                          >
                            {" "}
                            <i className="fas fa-fw fa-trash"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success"
                            disabled={this.state.loadingButton}
                            onClick={() => {
                              //   console.log(this.state.Localita[index]);
                              if (this.state.editLocalita.idArea === 0) {
                                this.state.aree.map((val2, index2) => {
                                  if (val2.nomeArea === localita.idArea) {
                                    this.state.editLocalita.idArea =
                                      val2.idArea;
                                  }
                                });
                              }
                              if (this.state.editLocalita.idLinea === 0) {
                                this.state.linee.map((val2, index2) => {
                                  if (val2.nomeLinea === localita.idLinea) {
                                    this.state.editLocalita.idLinea =
                                      val2.idLinea;
                                  }
                                });
                              }

                              this.lineaEdit = {
                                idArea: parseInt(
                                  this.state.editLocalita.idArea
                                ),
                                nomeLocalita:
                                  this.state.Localita[index].nomeLocalita,
                                idCliente: this.state.Localita[index].idCliente,
                                idLinea: parseInt(
                                  this.state.editLocalita.idLinea
                                ),
                                idLocalita:
                                  this.state.Localita[index].idLocalita,
                                importo: this.state.Localita[index].importo
                                  
                              };

                              if(this.lineaEdit.importo.toString()
                              .includes(".")){
                                this.lineaEdit.importo = this.lineaEdit.importo.toString()
                                  .replace(".", "")
                              }

                              if(this.lineaEdit.importo.toString()
                              .includes(",")){
                                this.lineaEdit.importo =  this.lineaEdit.importo.toString()
                                  .replace(",", "")
                              }

                              this.lineaEdit.importo = this.lineaEdit.importo.toString().length < 3 ? parseInt(this.lineaEdit.importo * 100) : this.lineaEdit.importo
                              
                              // console.log(this.lineaEdit);
                              this.setState({loadingButton:true})
                              this.dashboardLocalitaService.aggiornaLocaita(
                                this.lineaEdit,
                                (result) => {
                                  this.setState({loadingButton:false})
                                  if (result.status === 200) {
                                    toast.success("Località Aggiornata");
                                  } else {
                                    toast.error("Località non Aggiornata");
                                  }
                                  this.dashboardLocalitaService.getDataTableLocalita(
                                    (localita) => {
                                      localita.data.map((localita) => {
                                        localita.statobottne = true;
                                        localita.bottoniEditi = true;
                                        localita.importo = parseFloat(localita.importo / 100).toFixed(2).toString().replace(".",",")

                                        this.state.aree.map((val) => {
                                          if (val.idArea === localita.idArea) {
                                            localita.idArea = val.nomeArea;
                                          }
                                        });
                                        this.state.linee.map((val) => {
                                          if (
                                            val.idLinea === localita.idLinea
                                          ) {
                                            localita.idLinea = val.nomeLinea;
                                          }
                                        });
                                      });
                                      this.setState({
                                        Localita: localita.data,
                                      });
                                    }
                                  );
                                }
                              );
                            }}
                          >
                            {" "}
                            {this.state.loadingButton ? <LoadSpinner/> : <i className="fas fa-fw fa-check"></i> }
                            {" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            id={index}
                            onClick={() => {
                              // this.dashboardLocalitaService.getDataTableLocalita(
                              //   (Linee) => {
                              //     Linee.data.map((localita, indeds) => {
                              //       if (indeds === index) {
                              //         localita.statobottne = false;
                              //         localita.bottoniEditi = false;
                              //       } else {
                              //         localita.statobottne = true;
                              //         localita.bottoniEditi = true;
                              //       }
                              //     });
                              //     this.setState({ localita: Linee.data });
                              //   }
                              // );
                              // this.setState({ loading: false });
                              this.state.Localita.map((localita, indeds) => {
                                if (indeds === index) {
                                  localita.statobottne = true;
                                  localita.bottoniEditi = true;
                                } else {
                                  localita.statobottne = true;
                                  localita.bottoniEditi = true;
                                }
                              });
                              this.setState({ localita: localita });
                            }}
                          >
                            {" "}
                            <i className="fas fa-fw fa-times"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </>
    );
  }
  render() {
    // console.log(this.state.Localita);
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Località<br></br>
            </h1>
            {/* <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              > 
                Aree &#8594; In Lavorazione
              </small>< */}

            <button
              type="button"
              class="btn btn-warning"
              onClick={() => {
                this.setState({ AggiungiUnaLinea: true });
              }}
            >
              {" "}
              <i className="fas fa-plus fa-sm text-white"></i> &nbsp;Aggiungi
              una nuova Località
            </button>
            <a className=""></a>
          </div>
          <br />
          <br />
          <div className="col">{this.tabellaAree()}</div>
          {this.eliminaModal()}
          {this.AggiungiUnaLinea()}
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(Localita);
